// extracted by mini-css-extract-plugin
module.exports = {"closeBttn":"styles_closeBttn__3qp85","modal":"styles_modal__2PLEZ","modalBody":"styles_modalBody__3o9du"};